/**
 * De invulstatus van één meetmoment voor één deelnemer of huishouden.
 *
 * Er zijn drie waarden, niet twee, en die derde is het hele punt. Platformbreed
 * draagt maar 22% van de antwoorden een respondent-identiteit (2026-08-27); bij
 * anonieme groepsmetingen weten we simpelweg niet wie wat invulde. Wie dat als
 * "nog niet ingevuld" toont, stuurt begeleiders achter mensen aan die allang
 * klaar zijn — en dan gelooft niemand de lijst nog.
 *
 * Maar de twijfel geldt alleen waar iets te verbergen valt. De vraag is niet
 * "identificeert dit onderzoek?" maar "kan het antwoord van deze persoon
 * schuilgaan tussen de naamloze antwoorden op dít meetmoment?" Zijn er op dat
 * meetmoment geen naamloze antwoorden, dan is afwezigheid een zekerheid.
 *
 * Dat onderscheid is niet theoretisch: een gloednieuw onderzoek heeft nul
 * antwoorden. Met de oude vraag viel dat onder 'niet te zeggen' en verdween een
 * hele groep deelnemers die juist allemaal nog moesten beginnen.
 *
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 *
 * @param {object} args
 * @param {boolean} args.filled - Is er een antwoord van deze invuller op dit meetmoment?
 * @param {boolean|null} [args.couldBeHidden] - Zijn er naamloze antwoorden op dit meetmoment
 *   waartussen dat van deze invuller kan zitten? `null` = nog niet bekend.
 * @returns {'filled'|'missing'|'unknown'}
 */
const momentCompletionStatus = ({ filled, couldBeHidden } = {}) => {
    if (filled) return 'filled'
    if (couldBeHidden !== false) return 'unknown'
    return 'missing'
}

export default momentCompletionStatus
